<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
            </v-toolbar>
        </v-card>
        <v-card tile>
            <v-tabs
            v-model="tab"
            background-color="primary"
            dark
            center-active
            show-arrows
            grow
            >
                <v-tab>Personal Information</v-tab>
                <v-tab>Jobs</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-card flat color="#004889">
                        <v-card-text class="pa-0">
                            <ValidationObserver ref="observer1">
                                <v-form ref="personalform">
                                    <v-list flat color="#004889" class="py-0">
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Status</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Status" rules="required">
                                                    <v-select
                                                        v-model="form.status"
                                                        :items="statuses"
                                                        item-text="label"
                                                        item-value="value"
                                                        @change="submit"
                                                        required
                                                        :error-messages="errors"
                                                        solo
                                                        flat
                                                        dark
                                                        readonly
                                                    ></v-select>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">First Name</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="First Name" rules="required">
                                                    <v-text-field
                                                    v-model="form.first_name"
                                                    :error-messages="errors"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                    readonly
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Last Name</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Last Name" rules="required">
                                                    <v-text-field
                                                    v-model="form.last_name"
                                                    :error-messages="errors"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                    readonly
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Email</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Email" rules="email">
                                                    <v-text-field
                                                    v-model="form.email"
                                                    :error-messages="errors"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                    readonly
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Phone</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Phone" rules="required">
                                                    <v-text-field
                                                    v-model="form.phone"
                                                    :error-messages="errors"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                    readonly
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Street Address</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Street Address" rules="required">
                                                    <v-text-field
                                                    v-model="form.street_address"
                                                    :error-messages="errors"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                    readonly
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">City</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="City" rules="required">
                                                    <v-text-field
                                                    v-model="form.city"
                                                    :error-messages="errors"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                    readonly
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">ZIP Code</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Zip Code" rules="required">
                                                    <v-text-field
                                                    v-model="form.zip"
                                                    :error-messages="errors"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                    readonly
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">County</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="County" rules="required">
                                                    <v-autocomplete
                                                        :items="counties"
                                                        :filter="customFilter"
                                                        :error-messages="errors"
                                                        v-model="form.county"
                                                        color="white"
                                                        item-text="title"
                                                        item-value="id"
                                                        label="County"
                                                        required
                                                        solo
                                                        flat
                                                        dark
                                                        readonly
                                                    ></v-autocomplete>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>
                                </v-form>
                            </ValidationObserver>
                        </v-card-text>  
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card
                        class="mx-auto"
                        flat
                        :loading="loading"
                        loader-height="10"
                        tile
                    >
                        <v-toolbar
                        color="#0c477c"
                        dark
                        flat
                        height="40"
                        >
                            <v-spacer></v-spacer>
                            <v-toolbar-title class="jobs-count" >
                                {{ total + ' Jobs Found.' }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-list tile flat class="py-0" color="primary">
                            <template v-for="(job, index) in jobs">
                                <v-list-item
                                :key="`job-${index}`"
                                :value="job.id"                 
                                >
                                    <template>
                                        <v-list-item-content @click.stop="openJob(job.id)">
                                            <v-list-item-title class="white--text">
                                                {{ 'Job# ' + ('000000' + job.id).slice(-6) }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-chip
                                            :color="getColor(job.status)"
                                            text-color="white"
                                            label
                                            small
                                            >
                                                {{ job.status | capitalize }}
                                            </v-chip>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                                <v-divider
                                :key="`dv-${index}`"
                                ></v-divider>
                            </template>
                            <v-list-item v-if="pagination.total > 1">
                                <v-list-item-content>
                                    <v-pagination
                                        v-model="pagination.current"
                                        :length="pagination.total"
                                        @input="onPageChange"
                                        :total-visible="totalVisible"
                                    ></v-pagination>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
        <v-dialog
            v-model="dialogNewJob"
            persistent
            max-width="290"
        >
        <v-card color="primary">
            <v-card-title class="title text-uppercase justify-center white--text">
            Want to Create a Job?
            </v-card-title>
            <v-card-actions class="accent">
              <v-btn tile color="white darken-1" text @click="dialogNewJob = false">Cancel</v-btn>
              <v-btn tile color="accent--text" @click="createJob" :loading="loading">Create a Job</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import axios from 'axios'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    props: ['id'],
    data () {
        return {
            tab: null,
            form: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                street_address: '',
                city: '',
                state: 'AL',
                zip: '',
                service: 'Cleaning',
                county: null,
                status: '',
            },
            loading: false,
            jobs: [],
            pagination: {
                current: 1,
                total: 0
            },
            total: 0,
            totalVisible: 5,
            filter: {
                customer: "",
            },
            pageTitle: '',
            dialogNewJob: false
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.getCustomer()
        this.getJobs()
    },
    mounted() {
        if(this.$route.params.newjob) {
            this.dialogNewJob = true
        }
    },
    computed: {
        ...mapGetters({
            counties: 'data/counties',
            sizes: 'data/sizes',
            options: 'data/options',
            states: 'data/states',
            statuses: 'data/statusArray',
        }),
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    methods: {
        customFilter (item, queryText) {
            const textOne = item.title.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1
        },
        getJobs() {
            this.loading = true
            this.drawer = false
            this.$set(this.filter, 'customer', this.id)
            axios.get('crm/customer/jobs/all?page=' + this.pagination.current, {
                params: this.filter
            })
            .then(response => {
                this.loading = false
                this.jobs = response.data.jobs.data
                this.pagination.current = response.data.jobs.current_page
                this.pagination.total = response.data.jobs.last_page
                this.total = response.data.jobs.total
                this.$nextTick()
            })
        },
        onPageChange() {
            this.getJobs()
            this.$vuetify.goTo(0)
        },
        getCustomer() {
            if(this.id) {
                axios.get('crm/customers/get?id=' + this.id)
                    .then((response) => {
                        this.form = response.data

                        if(response.data.schedule !== null)
                            this.form.datetime = new Date(response.data.schedule)

                        this.form.status = response.data.status
                        this.$nextTick()
                    })
            }
        },
        getColor(status) {
            switch(status) {
                case 'completed':
                    return 'green'
                case 'active':
                    return 'light-blue'
                case 'cancelled':
                    return 'red'
                default:
                    // code block
            }
        },
        openJob(id) {
            this.$router.push({ path: '/job/main/'+id })
        },
        createJob() {
            this.$router.push({ name: 'New Job', params: { customer: this.form } })
        }
    }
}
</script>

<style lang="sass" scoped>
.admin-action 
    background: #1976d2
    button 
        width: 100%
        background: #ffffff
        color: #1976d2
.v-list-item__action
    .v-btn
        &:not(.v-btn--round)
            &.v-size--small
                height: 42px
.jobs-count 
    font-size: 14px
</style>